import { PATH_NAME } from "configs";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const AuthSync: React.FC = () => {
  const history = useHistory();

  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      if (event.key === "auth_token") {
        if (event.newValue) {
          // Auth token was added in another tab → login
          console.log("Auth token added - logging in from another tab");
          window.location.reload(); // or update auth context if you prefer
        } else {
          // Auth token was removed in another tab → logout
          console.log("Auth token removed - logging out from another tab");
          history.push(PATH_NAME.LOGIN);
        }
      }
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, [history]);

  return null;
};

export default AuthSync;
